import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/TipoFlete",
    name: "home",
    component: HomeView,
  },
  {
    path: "/FormularioFlete",
    name: "FormularioFlete",
    component: () => import("../views/FormularioFlete.vue"),
  },

  {
    path: "/ServiciosImportacion",
    name: "ServiciosImportacion",
    component: () => import("../views/ServiciosImportacion.vue"),
  },
  {
    path: "/RegistroCotizacion",
    name: "RegistroCotizacion",
    component: () => import("../views/RegistroCotizacion.vue"),
  },
  {
    path: "/CodigoFinal",
    name: "CodigoFinal",
    component: () => import("../views/CodigoFinal.vue"),
  },
  {
    path: "/ComparativoOpciones",
    name: "ComparativoOpciones",
    component: () => import("../views/ComparativoOpciones.vue"),
  },

  {
    path: "/CotizacionListado",
    name: "CotizacionListado",
    component: () => import("../views/CotizacionListado.vue"),
  },
  {
    path: "/CotizacionCompleta",
    name: "CotizacionCompleta",
    component: () => import("../views/CotizacionCompleta.vue"),
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // Rutas permitidas sin validación de session
  const rutasPermitidas = ["/", "/TipoFlete"];

  // Verificar la presencia de las claves requeridas
  const tieneSession = sessionStorage.getItem("tipo");

  // Si intenta ir a otra ruta distinta a las permitidas y NO tiene session, redirigir
  if (!rutasPermitidas.includes(to.path) && !tieneSession) {
    next("/"); // Redirige a la ruta principal
  } else {
    next(); // Permite el acceso
  }
});

export default router;
